import { useAuthUser } from "../hooks/useAuthUser";

type LogoutButtonProps = {
  type: "nav-link" | "btn";
};
const LogoutButton = (type: LogoutButtonProps) => {
  const { logout } = useAuthUser();
  const LogOutButton = (type: string) => {
    if (type === "nav-link") {
      return (
        <button className="btn nav-link" onClick={logout}>
          Log Out
        </button>
      );
    } else {
      return (
        <button className="btn" onClick={logout}>
          Log Out
        </button>
      );
    }
  };
  return LogOutButton(type.type);
};

export default LogoutButton;
